import Component from './containers/Card'

export default Component
